export const actionTypes = {
  REQUEST_START: 'TAPS.LAND_USE_TYPES.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.LAND_USE_TYPES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.LAND_USE_TYPES.REQUEST_FAILURE',
};

export function startRequest(filter) {
  return {
    type: actionTypes.REQUEST_START,
    payload: filter,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
